/**
 * Author: Semen Semenov
 * Date: 6/29/2018
 * Project: React Redux Quotes App with CRUD operations
 */

export const SAVE_PROFILE = "SAVE_PROFILE";
export const SAVE_UID = "SAVE_UID";
export const SAVE_USERS = "SAVE_USERS";
export const REMOVE = "REMOVE";
export const SAVE_RENTERS = "SAVE_RENTERS";
export const SAVE_PROPERTIES = "SAVE_PROPERTIES";
export const SAVE_BRAND = "SAVE_BRAND";
export const SAVE_UNREADS = "SAVE_UNREADS";
export const SAVE_BRAND_UNREADS = "SAVE_BRAND_UNREADS";
export const SAVE_SUPER_UNREADS = "SAVE_SUPER_UNREADS";
export const SAVE_SUPER_CONTENTS = "SAVE_SUPER_CONTENTS";
export const SAVE_SUPER_QUESTIONS = "SAVE_SUPER_QUESTIONS";
export const SAVE_SUB_BRANDS = "SAVE_SUB_BRANDS";
export const SAVE_MY_ROLE = "SAVE_MY_ROLE";
export const SAVE_ALL_RETAILERS = "SAVE_ALL_RETAILERS";
export const SET_NOTIFICATION_SOUND_PLAYED = "SET_NOTIFICATION_SOUND_PLAYED";

export const saveProfile = (profile) => ({
  type: SAVE_PROFILE,
  profile: profile,
});
export const saveProperties = (properties) => ({
  type: SAVE_PROPERTIES,
  properties: properties,
});
export const saveBrand = (brand) => ({
  type: SAVE_BRAND,
  brand: brand,
});
export const saveUID = (uid) => ({ type: SAVE_UID, uid: uid });
export const saveUsers = (users) => ({
  type: SAVE_USERS,
  users: users,
});
export const saveRenters = (renters) => ({
  type: SAVE_RENTERS,
  renters: renters,
});
export const saveUnreadSupportMessages = (unreads) => ({
  type: SAVE_UNREADS,
  unreads: unreads,
});
export const saveUnreadMessagesFromSuper = (unreads) => ({
  type: SAVE_BRAND_UNREADS,
  unreads: unreads,
});
export const saveSuperUnreadMessages = (unreads) => ({
  type: SAVE_SUPER_UNREADS,
  unreads: unreads,
});
export const saveSuperContents = (super_contents) => ({
  type: SAVE_SUPER_CONTENTS,
  super_contents: super_contents,
});
export const saveSuperQuestions = (super_questions) => ({
  type: SAVE_SUPER_QUESTIONS,
  super_questions: super_questions,
});
export const saveAllRetailers = (allRetailers) => ({
  type: SAVE_ALL_RETAILERS,
  allRetailers: allRetailers,
});
export const saveMyRole = (myRole) => ({
  type: SAVE_MY_ROLE,
  myRole: myRole,
});
export const saveSubBrands = (subBrands) => ({
  type: SAVE_MY_ROLE,
  subBrands: subBrands,
});
export const removeAll = () => ({
  type: REMOVE,
});
export const setNotificationSoundPlayed = (hasPlayed) => ({
  type: SET_NOTIFICATION_SOUND_PLAYED,
  hasPlayed: hasPlayed,
});



// WEBPACK FOOTER //
// ./src/redux/actions/index.js